
import { TCompliantBlockRow } from "@/models/compliant_block";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    CompliantBlockRow: () =>
      import("@/modules/Compliance/ComplianceWidgets/components/CompliantBlockRow.vue"),
  },
})
export default class CompliantBlock extends Vue {
  @Prop({ type: String, required: true }) readonly label!: string;
  @Prop({ type: Array, default: () => [] }) readonly rows!: TCompliantBlockRow[];
  @Prop({ type: Boolean, default: false }) readonly blocked!: boolean;

  get hasRows() {
    return this.rows.length > 0;
  }
}
